import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import GTMHelper from '../../../Helpers/gtmHelper';
import ThreeSixtyView from '../../2_Molecules/360View/360View';
import ThreeSixtyInteriorView from '../../2_Molecules/360InteriorView/360InteriorView';
import { Svg } from '../../1_Atoms/Svg/Svg';
import { useTranslation } from "react-i18next";


export const ThreeSixtyContainer = ({ imagePathInterior, imagePath, imageAmount, imageName, trimName, imageIsLoading, ...props }) => {
    const [vehicleTrimName, setTrimName] = React.useState(trimName);
    const [active360, setActive360] = React.useState('exterior');
    //const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const { t, i18n } = useTranslation(['general']);
	const gtmHelper = new GTMHelper();

    function toggleView() {
        var activeView = active360 === 'interior' ? 'exterior' : 'interior';
        setActive360(activeView);
		gtmHelper.setGTM({'action':'Change 360 View', '360 View': activeView}, true , false);
    }

    // This will launch only if trimName value has chaged.
    React.useEffect(() => {
        setTrimName(trimName);

        setIsLoading(imageIsLoading);
    }, [trimName, imagePath, imageIsLoading]);

    return (
        <div className='mz-360-container'>
            <h2 className="mz-360-container__tittle">{ReactHtmlParser(vehicleTrimName ? vehicleTrimName : '')}</h2>
                {active360 === 'interior' ? <ThreeSixtyInteriorView imagePath={imagePathInterior}></ThreeSixtyInteriorView>
                    : <ThreeSixtyView imagePath={imagePath} imageAmount={imageAmount} imageName={imageName} isLoading={isLoading}></ThreeSixtyView>}
                <div className="mz-360-container__controls">
                    <button className="mz-360-container__controls-button mz-360-container__controls-button-drag-copy">
                        <Svg
                            colour="grey"
                            svg_list="threesixty"
                            svg_classname="threesixty"
                        />
                        {t("general:drag_to_view_360")}
                    </button>
                    <div className="mz-360-container__controls-actions">
                        <button className="mz-360-container__controls-button interactive" onClick={() => toggleView()}>
                            <Svg
                                colour="grey"
                                svg_list={active360 !== 'interior' ? 'steeringwheel' : 'carexterior'}
                            />
                            {active360 !== 'interior' ? t("general:interior_view_360") : t("general:exterior_view_360")}
                        </button>
                    </div>
                </div>
        </div>

    )
}

export default ThreeSixtyContainer;